import {
  LearnMoreDemoOpsIllustration,
  LearnMoreEnablementIllustration,
  LearnMorePresalesIllustration,
  LearnMoreSalesforceIllustration,
} from '@carboncopyco/illustrations';
import { Paper, TextLargeParagraphTitle } from '@carboncopyco/ui';
import { LearnMoreTile } from './LearnMoreTile';

const config = [
  {
    image: (
      <LearnMoreDemoOpsIllustration
        width="100%"
        height="100%"
      />
    ),
    text: 'Use analytics for your demo operation',
    link: 'https://20453961.fs1.hubspotusercontent-na1.net/hubfs/20453961/New%20Brand%20-%20PDFs/PSC_Demostack_Whitepaper.pdf',
  },
  {
    image: (
      <LearnMorePresalesIllustration
        width="100%"
        height="100%"
      />
    ),
    text: 'Enable buyers and get more engagement data',
    link: 'https://www.demostack.com/post/how-to-leverage-ses-efficiently-and-win-more-deals',
  },
  {
    image: (
      <LearnMoreSalesforceIllustration
        width="100%"
        height="100%"
      />
    ),
    text: 'Sync your demo analytics with Salesforce',
    link: 'https://www.demostack.com/platform/integration/salesforce',
  },
  {
    image: (
      <LearnMoreEnablementIllustration
        width="100%"
        height="100%"
      />
    ),
    text: 'Use analytics to allocate presales resources',
    link: 'https://www.demostack.com/solutions/buyer-enablement',
  },
];

export const LearnMore = () => {
  return (
    <Paper
      border="ds-regular"
      padding="xl"
      radius
    >
      <TextLargeParagraphTitle
        label="Learn more"
        color="text-ds-natural-600"
      />
      <div className="flex gap-5 w-full justify-evenly pt-4.5">
        {config.map(({ link, text, image }) => (
          <LearnMoreTile
            key={link}
            text={text}
            link={link}
          >
            {image}
          </LearnMoreTile>
        ))}
      </div>
    </Paper>
  );
};
